<template>
  <div class="Slider" v-if="sliderData">
    <div class="Slider__body">
      <video v-for="(item, index) in sliderData" :key="item.title" v-if="currentItm == (index+1) " autoplay muted
        :src="item.video" loop></video>
      <div class="grd_bg"></div>
      <div class="container Slider__body__content">
        <div class="row">
          <div class="col-md-8 center_content">
            <div class="Slider__body__content__info">
              <h1> MI Videos </h1>
              <transition name="transitionSide">
                <div class="Slider__body__content__info__row1" v-for="(item, index) in sliderData" :key="item"
                  v-if="currentItm == (index+1) ">
                  <div class="play-icon">
                    <a @click="playVideo( $event,item.video)">
                      <img src="/static/cdn/play_snpjdl.svg">

                    </a>
                  </div>
                  <h2>{{item.title}}</h2>
                  <p>
                    {{item.text}}
                  </p>
                  <a @click="playVideo( $event,item.video)" class="button button--transparent-grad pulse  ">
                    Play
                  </a>
                </div>
              </transition>

              <div class="actions">
                <span class="currentSlider">
                  0{{currentItm}}
                </span>
                <div :class="{disactive:currentItm == 1  }" @click="righttHandler()" class="prev-btn">
                  Prev
                </div>
                <div :class="{disactive:currentItm == sliderData.length  }" @click="leftHandler()" class="next-btn">
                  Next
                </div>
               
              </div>
            </div>
          </div>
          <div class="col-md-4 flex">
            <div class="slider__videos">
              <div class="spliter">

              </div>
              <div v-for="(item, index) in sliderData" :key="item.id" :class="{'active': (index+1)== currentItm}"
                @click="currentItm =(index+1)" class="slider__videos__item">
                <span> {{item.title}}</span>
              </div>

            </div>

          </div>

        </div>

      </div>

    </div>


    <div class="container mobslider">
      <h1>MI Videos </h1>
      <div class="row ">
        <div class="col-sm-6 " v-for="(item, index) in sliderData" :key="item.title" data-aos="zoom-in"
          @click="playVideo( $event,item.video)">
          <div class="mob-video">
            <div class="video-thumb">
              <img :src="item.thumb">
            </div>
            <h2>
              {{item.title}}
            </h2>
          </div>
        </div>
      </div>
    </div>             
       <router-link to="/videos" class="Slider__body__content__info__show_all button button--transparent-grad pulse">Show all  </router-link>
  </div>
</template>

<script>
  import BigPicture from 'bigpicture';
  import videosData from '@/assets/data/videosData';
  export default {
    name: 'slider',
    data: function () {
      return {
        currentItm: 1,
        sliderData:videosData
      }
    },

    methods: {
      showTab: function (tabNum) {
        this.currentItm = tabNum;
      },
      leftHandler: function () {

        if (this.sliderData.length > this.currentItm) {
          this.currentItm++;
          console.log(this.currentItm, "currentItm new val");
        }
      },
      righttHandler: function () {
        if (this.currentItm > 1) {
          this.currentItm--;
          console.log(this.currentItm, "currentItm new val");

        }
      },
      playVideo(e, video) {
        console.log("triggered");
        BigPicture({
          el: e.target,
          // video src (String) or sources (Array)
          vidSrc: [video],
        });
      }
    },
    mounted() {
   
    }
  };

</script>

<style lang="scss">
  @import './style.scss';

</style>



// WEBPACK FOOTER //
// src/components/Page/Slider/index.vue